import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  GrantTerm,
  GrantedArea,
  KSANCardNumberIssued,
  NameLowercase,
  Note,
  PersonalId,
  Regency,
  Sex,
  Team,
} from "./_fields";

type SecurityControlLongTermRenewTemplate = {
  unit: string;
  name: string;
  sex: string;
  personalId: number;
  regency: string;
  KSANCardNumberIssued: string;
  grantTerm: string;
  grantedArea: string;
  note: string;
};

export const securityControlLongTermRenewTemplate: TemplatesValue<SecurityControlLongTermRenewTemplate> =
  {
    fileName: "DanhSachNhanVienDaiHanCapLai",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        ...Team,
        header: "Đơn vị",
      },
      NameLowercase,
      Sex,
      PersonalId,
      Regency,
      KSANCardNumberIssued,
      GrantTerm,
      {
        ...GrantedArea,
        header: "Khu vực được cấp",
      },
      Note,
    ],
    fields: [
      "unit",
      "name",
      "sex",
      "personalId",
      "regency",
      "KSANCardNumberIssued",
      "grantTerm",
      "grantedArea",
      "note",
    ],
  };
